module.exports = __webpack_public_path__ + "static/media/AVISOIMPORTANTEnero2026.32b4afd4.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/AVISOIMPORTANTEnero2026.pdf
// module id = 968
// module chunks = 0